export const socialMediaLinksData = [
    {
        id: 1,
        icon: <i className="fa-brands fa-instagram text-xl"></i>,
        link: "https://www.instagram.com/girlifycoder"
    },
    {
        id: 2,
        icon: <i className="fa-brands fa-facebook text-xl"></i>,
        link: "https://www.facebook.com/khushi.johri01"
    },
    {
        id: 3,
        icon: <i className="fa-brands fa-twitter text-xl"></i>,
        link: "https://twitter.com/khushijohri01?s=08"
    },
    {
        id: 4,
        icon: <i className="fa-brands fa-linkedin text-xl"></i>,
        link: "https://www.linkedin.com/in/khushi-johri-b74970202"
    },
    {
        id: 5,
        icon:  <i className="fa-brands fa-github text-xl"></i>,
        link: "https://github.com/khushijohri2001"
    },
]
